<template>
  <AppPageContainer :showNav="false" :clean="true" :background="'calendar'">
    <div class="notespace">
      <div class="notespace--container">
        <div class="notespace--subcontainer">
          <div v-for="(group, index) in notesWithYearHeaders" :key="index">
            <!-- Year header if the year changes and is not the current year -->
            <div v-if="group.showYearHeader" class="yearHeader">
              {{ group.year }}
            </div>
            <!-- Dates and notes -->
            <div v-for="(notes, date) in group.dates" :key="date" class="notespace--dateblock">
              <!-- Display the formatted date -->
              <div class="notespace--date">{{ formatDate(date) }}</div>
              <!-- Loop through the notes for the current date -->
              <div>
                <div
                  v-for="note in notes"
                  :key="note.id"
                  class="notespace--note"
                  :class="note.selected ? 'notespace--note--selected' : ''"
                  @click="selectNote(note)"
                >
                  <div class="notespace--note--content" :class="note.selected ? 'notespace--note--content--selected' : ''">{{ note.content }}</div>
                  <div class="notespace--controls" v-show="note.selected">
                    <div class="notespace--controls--button">
                      <svg
                        aria-hidden="true"
                        class="sfa text-[1.1rem] svelte-1tu5i4y"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path
                          fill="currentColor"
                          d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
                        ></path>
                      </svg>
                    </div>
                    <div class="notespace--controls--button">
                      <svg
                        aria-hidden="true"
                        class="sfa text-[1.1rem] svelte-1tu5i4y"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <path
                          fill="currentColor"
                          d="M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"
                        ></path>
                      </svg>
                    </div>
                    <div class="notespace--controls--button">
                      <svg
                        aria-hidden="true"
                        class="sfa text-[1rem svelte-1tu5i4y"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppPageContainer>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";
import { format, parseISO, getYear as getDateYear } from "date-fns";

export default {
  components: {
    AppPageContainer,
  },
  data() {
    return {
      notesByDate: {
        "2023-11-08": [
          {
            id: 1,
            content:
              "What if you had 'My Day' on one side and 'Daily Thoughts/Journal/Notes' on the other? And then just as a cherry on top, a daily tracker, for sleep, eating and so on...",
            selected: false,
          },
          {
            id: 2,
            content:
              "Tellus rutrum tellus pellentesque eu tincidunt tortor aliquam nulla facilisi. Laoreet non curabitur gravida arcu ac tortor. Habitant morbi tristique senectus et netus et malesuada fames. Vel fringilla est ullamcorper eget nulla facilisi etiam dignissim. Porttitor rhoncus dolor purus non enim praesent. Morbi tristique senectus et netus et malesuada. Neque aliquam vestibulum morbi blandit. Nec nam aliquam sem et tortor consequat id porta. Bibendum neque egestas congue quisque egestas diam. Malesuada fames ac turpis egestas maecenas pharetra. Iaculis urna id volutpat lacus laoreet non curabitur gravida arcu. Enim nulla aliquet porttitor lacus.",
            selected: false,
          },
          {
            id: 3,
            content:
              "Some thoughts here and there... of course, we have not explored to the fullest what it would be like to make these notes a little bigger! Like boys and girls, let us not hold back in such delicate matters that evidently do require a great amount of care and thought.",
            selected: false,
          },
        ],
        "2023-11-07": [
          {
            id: 4,
            content:
              "Oh, and, what if you had a block that could accept checklists/tasks? Or even better, just allow checklists like Apple notes has from the start.",
            selected: false,
          },
          {
            id: 5,
            content:
              "Varius quam quisque id diam vel. Sed elementum tempus egestas sed sed. Eget egestas purus viverra accumsan in. Ultricies mi quis hendrerit dolor. Hendrerit dolor magna eget est lorem ipsum dolor sit. Est pellentesque elit ullamcorper dignissim cras tincidunt lobortis feugiat. Tristique senectus et netus et malesuada fames. Sapien faucibus et molestie ac feugiat sed lectus vestibulum. Purus ut faucibus pulvinar elementum integer enim. Et molestie ac feugiat sed lectus vestibulum mattis ullamcorper velit.",
            selected: false,
          },
          {
            id: 6,
            content: "And what if... you could just pop this thing into view, any time, from anywhere, as a sort of overlay? Blur as an option.",
            selected: false,
          },
        ],
        "2023-11-06": [
          { id: 7, content: "And therein lies the struggle", selected: false },
          { id: 8, content: "Of creating something GREAT", selected: false },
          { id: 9, content: "A true struggle it is.", selected: false },
        ],
        "2022-11-08": [
          {
            id: 10,
            content:
              "In hendrerit gravida rutrum quisque non. Sed euismod nisi porta lorem. Arcu ac tortor dignissim convallis aenean et. Scelerisque in dictum non consectetur a erat nam at. Vulputate eu scelerisque felis imperdiet proin. Scelerisque eu ultrices vitae auctor eu augue. Eget aliquet nibh praesent tristique magna. Pellentesque nec nam aliquam sem et tortor consequat id porta. Urna neque viverra justo nec ultrices dui sapien eget mi. Turpis egestas integer eget aliquet nibh praesent. Nulla malesuada pellentesque elit eget gravida cum sociis.",
            selected: false,
          },
          {
            id: 11,
            content:
              "Phasellus vestibulum lorem sed risus ultricies tristique nulla aliquet enim. Risus quis varius quam quisque id diam vel. Aliquet eget sit amet tellus cras adipiscing enim. Arcu felis bibendum ut tristique et egestas quis ipsum. Tristique senectus et netus et malesuada fames ac turpis egestas. Porta nibh venenatis cras sed felis eget. Lacus vestibulum sed arcu non. Id donec ultrices tincidunt arcu non. Ut pharetra sit amet aliquam id. Tellus in hac habitasse platea dictumst vestibulum rhoncus est. Neque sodales ut etiam sit amet nisl purus in. Pellentesque sit amet porttitor eget. Quis risus sed vulputate odio ut enim blandit. Adipiscing elit ut aliquam purus.",
            selected: false,
          },
          {
            id: 12,
            content:
              "Adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus urna neque. Id cursus metus aliquam eleifend. Posuere urna nec tincidunt praesent semper feugiat nibh sed. Dictum sit amet justo donec. Viverra maecenas accumsan lacus vel facilisis.",
            selected: false,
          },
        ],
        "2022-11-07": [
          { id: 13, content: "No doubt, you must be able to add images.", selected: false },
          {
            id: 14,
            content:
              "The way the Journal app lets you customize itself is pretty brilliant. We should let people customize damn everything, from line height to font size to all sorts of colors.",
            selected: false,
          },
          { id: 15, content: "Drag and drop is a necessity... but also some sort of edit history.", selected: false },
        ],
        "2022-11-06": [
          {
            id: 16,
            content:
              "I've rarely understood or found that anyone has just 'one type of thought' a day. A single note card or note per day just does not do justice.",
            selected: false,
          },
          { id: 17, content: "Tags could add a lot of color (if people want them visible).", selected: false },
          { id: 18, content: "Let people change the hover background color", selected: false },
          { id: 19, content: "What if you could highlight some text and leave it so?", selected: false },
          { id: 20, content: "Quick button to copy text or image to clipboard", selected: false },
          { id: 21, content: "Option to have previous days collapsed or hidden.", selected: false },
        ],
      },
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    notesWithYearHeaders() {
      let lastYearRendered = null;
      return Object.entries(this.notesByDate).reduce((acc, [date, notes], index) => {
        const yearOfNote = getDateYear(parseISO(date));
        const showYearHeader = yearOfNote !== this.currentYear && yearOfNote !== lastYearRendered;
        if (showYearHeader) {
          lastYearRendered = yearOfNote;
        }
        if (showYearHeader || index === 0) {
          acc.push({ showYearHeader, year: yearOfNote, dates: { [date]: notes } });
        } else {
          acc[acc.length - 1].dates[date] = notes;
        }
        return acc;
      }, []);
    },
  },
  methods: {
    formatDate(date) {
      const parsedDate = parseISO(date);
      return format(parsedDate, "MMM d, yyyy");
    },
    selectNote(note) {
      note.selected = !note.selected;
    },
  },
};
</script>

<style>
.notespace {
  height: 100%;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* backdrop-filter: blur(7px); */
}
.notespace--container {
  max-width: 650px;
  width: 95%;
  max-height: 95%;
  padding: 10px;
  /* padding-top: 30px; */
  /* box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%); */
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  /* backdrop-filter: blur(5px); */
  box-sizing: border-box;
  display: flex;
  -webkit-backdrop-filter: blur(var(--blur));
  backdrop-filter: blur(2rem);
  border: 1px solid rgb(150 150 150 / 20%);
  transition: border-color 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  /* box-shadow: 0 0 10px 1px #0000001a; */
  background-color: transparent;
  flex-direction: column;
}
.notespace--subcontainer {
  /* box-shadow: 0 0 10px 1px #0000001a; */
  background-color: rgb(18 18 18 / 80%);
  border-radius: 16px;
  /* backdrop-filter: blur(15px); */
  padding: 5px;
  padding-top: 15px;
  border: 1px solid rgb(255 255 255 / 15%);
  box-shadow: 0 0 10px 1px #0000001a;
  overflow-y: scroll;
}
.notespace--dateblock {
  margin-bottom: 20px;
  /* box-shadow: 0 0 10px 1px #0000001a; */
  /* background-color: rgb(18 18 18 / 80%); */
  border-radius: 16px;
  /* backdrop-filter: blur(15px); */
  padding: 5px;
  /* border: 1px solid rgb(255 255 255 / 15%); */
  /* box-shadow: 0 0 10px 1px #0000001a; */
}
.notespace--date {
  color: rgb(223 223 223 / 60%);
  font-size: 16px;
  margin-bottom: 0px;
  transition: 0.3s ease-in-out;
  /* opacity: 0; */
  padding: 5px 5px;
  border-radius: 12px;
  /* box-shadow: 0 0 10px 1px #0000001a; */
  /* background-color: rgb(19 19 19 / 15%); */
  /* backdrop-filter: blur(5px); */
  /* display: none; */
  cursor: default;
  /* background-color: rgb(19 19 19 / 80%); */
  padding: 6px 15px;
  color: #666666;
  /* backdrop-filter: blur(15px); */
  padding: 12px 15px;
  color: #eee;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Edge */
}
.notespace--date:hover {
  /* background-color: rgb(19 19 19 / 53%); */
  padding: 15px 15px;
  color: white;
}
.notespace--note {
  align-items: flex-start;
  justify-content: center;
  padding: 14px 15px;
  /* padding: 5px; */
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  /* background-color: rgba(255, 255, 255, 0.5); */
  -webkit-backdrop-filter: blur(5px);
  /* backdrop-filter: blur(46px); */
  box-sizing: border-box;
  display: flex;
  -webkit-backdrop-filter: blur(var(--blur));
  /* backdrop-filter: blur(2rem); */
  border: 1px solid rgb(255 255 255 / 15%);
  transition: border-color 0.3s ease-in-out;
  /* transition: all 0.2s ease-in-out; */
  /* box-shadow: 0 0 10px 1px #0000001a; */
  /* background-color: rgb(19 19 19 / 80%); */
  margin: -5px 0px;
  width: auto;
  color: #8f8f8f;
  font-size: 16px;
  /* box-shadow: 0 0 0 1px rgba(15,15,15,.05), 0 3px 6px rgba(15,15,15,.1), 0 9px 24px hsla(0,0%,83.5%,.2); */
  /* background-color: hsla(0,0%,100%,.8)!important; */
  /* backdrop-filter: blur(15px); */
  /* color: #333; */
  /* background-color: #ffffff; */
  line-height: 26px;
  transition: 0.3s ease-out;
  border-color: transparent;
  /* border-radius: 0px !important; */
  min-height: 56px;
  cursor: default;
  flex-direction: column;
  position: relative;
}
.notespace--note:hover {
  background-color: rgb(19 19 19 / 80%);
  /* padding: 15px; */
  box-shadow: 0 0 10px 1px #0000001a;
  /* backdrop-filter: blur(15px); */
  border: 1px solid rgb(255 255 255 / 15%);
  color: #ddd;
}
.notespace--note--selected {
  background-color: rgb(19 19 19 / 80%);
  /* padding: 15px; */
  box-shadow: 0 0 10px 1px #0000001a;
  /* backdrop-filter: blur(15px); */
  border: 1px solid rgb(255 255 255 / 15%);
  color: #ddd;
}
.yearHeader {
  font-size: 20px;
  color: #ccc;
  padding: 15px 15px;
  text-align: center;
  margin-top: 30px;
}

.notespace--controls {
  position: absolute;
  bottom: 5px;
  right: 15px;
  display: flex;
  padding: 5px 0px;
}

.notespace--controls--button {
  margin: 0px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notespace--controls--button svg {
  width: 1em;
  height: 1em;
}
.notespace--note--content {
  transition: 0.3s ease-out;
}
.notespace--note--content--selected {
  padding-bottom: 20px;
}
</style>
